var items = {
  "block.minecraft.air": "loft",
  "block.minecraft.stone": "steinn",
  "block.minecraft.granite": "granít",
  "block.minecraft.polished_granite": "slípað granít",
  "block.minecraft.diorite": "díórít",
  "block.minecraft.polished_diorite": "slípað díórít",
  "block.minecraft.andesite": "andesít",
  "block.minecraft.polished_andesite": "slípað andesít",
  "block.minecraft.grass_block": "graskubbur",
  "block.minecraft.dirt": "mold",
  "block.minecraft.coarse_dirt": "gróf mold",
  "block.minecraft.podzol": "mór",
  "block.minecraft.crimson_nylium": "hárautt heljarmygli",
  "block.minecraft.warped_nylium": "brenglað heljarmygli",
  "block.minecraft.cobblestone": "grjót",
  "block.minecraft.oak_planks": "eikarplankar",
  "block.minecraft.spruce_planks": "greniplankar",
  "block.minecraft.birch_planks": "birkiplankar",
  "block.minecraft.jungle_planks": "frumskógsplankar",
  "block.minecraft.acacia_planks": "akasíuplankar",
  "block.minecraft.dark_oak_planks": "dökkeikarplankar",
  "block.minecraft.crimson_planks": "hárauðir plankar",
  "block.minecraft.warped_planks": "brenglaðir plankar",
  "block.minecraft.oak_sapling": "eikargræðlingur",
  "block.minecraft.spruce_sapling": "grenigræðlingur",
  "block.minecraft.birch_sapling": "birkigræðlingur",
  "block.minecraft.jungle_sapling": "frumskógargræðlingur",
  "block.minecraft.acacia_sapling": "akasíugræðlingur",
  "block.minecraft.dark_oak_sapling": "dökkeikargræðlingur",
  "block.minecraft.bedrock": "berggrunnur",
  "block.minecraft.sand": "sandur",
  "block.minecraft.red_sand": "rauðsandur",
  "block.minecraft.gravel": "möl",
  "block.minecraft.gold_ore": "gullgrýti",
  "block.minecraft.iron_ore": "járngrýti",
  "block.minecraft.coal_ore": "kolagrýti",
  "block.minecraft.nether_gold_ore": "heljargullgrýti",
  "block.minecraft.oak_log": "eikardrumbur",
  "block.minecraft.spruce_log": "grenidrumbur",
  "block.minecraft.birch_log": "birkidrumbur",
  "block.minecraft.jungle_log": "frumskógsdrumbur",
  "block.minecraft.acacia_log": "akasíudrumbur",
  "block.minecraft.dark_oak_log": "dökkeikardrumbur",
  "block.minecraft.crimson_stem": "hárauður stilkur",
  "block.minecraft.warped_stem": "brenglaður stofn",
  "block.minecraft.stripped_oak_log": "afrifinn eikardrumbur",
  "block.minecraft.stripped_spruce_log": "afrifinn grenidrumbur",
  "block.minecraft.stripped_birch_log": "afrifinn birkidrumbur",
  "block.minecraft.stripped_jungle_log": "afrifinn frumskógsdrumbur",
  "block.minecraft.stripped_acacia_log": "afrifinn akasíudrumbur",
  "block.minecraft.stripped_dark_oak_log": "afrifinn dökkeikardrumbur",
  "block.minecraft.stripped_crimson_stem": "strípaður hárauður stilkur",
  "block.minecraft.stripped_warped_stem": "afrifinn brenglaður stofn",
  "block.minecraft.stripped_oak_wood": "afrifinn eikarviður",
  "block.minecraft.stripped_spruce_wood": "afrifinn greniviður",
  "block.minecraft.stripped_birch_wood": "afrifinn birkiviður",
  "block.minecraft.stripped_jungle_wood": "afrifinn frumskógsviður",
  "block.minecraft.stripped_acacia_wood": "afrifinn akasíuviður",
  "block.minecraft.stripped_dark_oak_wood": "afrifinn dökkeikarviður",
  "block.minecraft.stripped_crimson_hyphae": "strípaðir hárauðir sveppaþræðir",
  "block.minecraft.stripped_warped_hyphae": "strípaðir brenglaðir sveppaþræðir",
  "block.minecraft.oak_wood": "eikarviður",
  "block.minecraft.spruce_wood": "greniviður",
  "block.minecraft.birch_wood": "birkiviður",
  "block.minecraft.jungle_wood": "frumskógarviður",
  "block.minecraft.acacia_wood": "akasíuviður",
  "block.minecraft.dark_oak_wood": "dökkeikarviður",
  "block.minecraft.crimson_hyphae": "hárauðir sveppaþræðir",
  "block.minecraft.warped_hyphae": "brenglaðir sveppaþræðir",
  "block.minecraft.oak_leaves": "eikarlauf",
  "block.minecraft.spruce_leaves": "greninálar",
  "block.minecraft.birch_leaves": "birkilauf",
  "block.minecraft.jungle_leaves": "frumskógarlauf",
  "block.minecraft.acacia_leaves": "akasíulauf",
  "block.minecraft.dark_oak_leaves": "dökkeikarlauf",
  "block.minecraft.sponge": "svampur",
  "block.minecraft.wet_sponge": "blautur svampur",
  "block.minecraft.glass": "gler",
  "block.minecraft.lapis_ore": "asúrsteinn",
  "block.minecraft.lapis_block": "asúrsteinskubbur",
  "block.minecraft.dispenser": "skammtari",
  "block.minecraft.sandstone": "sandsteinn",
  "block.minecraft.chiseled_sandstone": "útskorinn sandsteinn",
  "block.minecraft.cut_sandstone": "skorinn sandsteinn",
  "block.minecraft.note_block": "nótnakubbur",
  "block.minecraft.powered_rail": "orku teinar",
  "block.minecraft.detector_rail": "teinnemi",
  "block.minecraft.sticky_piston": "klístraður stimpill",
  "block.minecraft.cobweb": "köngulóarvefur",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "burkni",
  "block.minecraft.dead_bush": "dauður runni",
  "block.minecraft.seagrass": "sægras",
  "block.minecraft.sea_pickle": "sjávargúrka",
  "block.minecraft.piston": "stimpill",
  "block.minecraft.white_wool": "hvít ull",
  "block.minecraft.orange_wool": "appelsínugul ull",
  "block.minecraft.magenta_wool": "vínrauð ull",
  "block.minecraft.light_blue_wool": "ljósblá ull",
  "block.minecraft.yellow_wool": "gul ull",
  "block.minecraft.lime_wool": "ljósgræn ull",
  "block.minecraft.pink_wool": "bleik ull",
  "block.minecraft.gray_wool": "grá ull",
  "block.minecraft.light_gray_wool": "ljósgrá ull",
  "block.minecraft.cyan_wool": "heiðblá ull",
  "block.minecraft.purple_wool": "fjólublá ull",
  "block.minecraft.blue_wool": "blá ull",
  "block.minecraft.brown_wool": "brún ull",
  "block.minecraft.green_wool": "græn ull",
  "block.minecraft.red_wool": "rauð ull",
  "block.minecraft.black_wool": "svört ull",
  "block.minecraft.dandelion": "túnfífill",
  "block.minecraft.poppy": "valmúi",
  "block.minecraft.blue_orchid": "blátt brönugras",
  "block.minecraft.allium": "villilaukur",
  "block.minecraft.azure_bluet": "bláeyg",
  "block.minecraft.red_tulip": "rauður túlípani",
  "block.minecraft.orange_tulip": "appelsínugulur túlípani",
  "block.minecraft.white_tulip": "hvítur túlípani",
  "block.minecraft.pink_tulip": "bleikur túlípani",
  "block.minecraft.oxeye_daisy": "freyjubrá",
  "block.minecraft.cornflower": "garðakornblóm",
  "block.minecraft.lily_of_the_valley": "dalalilja",
  "block.minecraft.wither_rose": "visnuð rós",
  "block.minecraft.brown_mushroom": "brúnn sveppakubbur",
  "block.minecraft.red_mushroom": "rauður sveppur",
  "block.minecraft.crimson_fungus": "hárauður sveppur",
  "block.minecraft.warped_fungus": "brenglaður sveppur",
  "block.minecraft.crimson_roots": "hárautt heljargras",
  "block.minecraft.warped_roots": "brenglað heljargras",
  "block.minecraft.nether_sprouts": "heljarspírur",
  "block.minecraft.weeping_vines": "grátvínviður",
  "block.minecraft.twisting_vines": "vafningsviður",
  "block.minecraft.sugar_cane": "sykurreyr",
  "block.minecraft.kelp": "þari",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "gullkubbur",
  "block.minecraft.iron_block": "járnkubbur",
  "block.minecraft.oak_slab": "eikarhella",
  "block.minecraft.spruce_slab": "grenihella",
  "block.minecraft.birch_slab": "birkihella",
  "block.minecraft.jungle_slab": "frumskógarviðarhella",
  "block.minecraft.acacia_slab": "akasíuplata",
  "block.minecraft.dark_oak_slab": "dökkeikarhella",
  "block.minecraft.crimson_slab": "hárauð hella",
  "block.minecraft.warped_slab": "brengluð hella",
  "block.minecraft.stone_slab": "steinhella",
  "block.minecraft.smooth_stone_slab": "slípuð steinhella",
  "block.minecraft.sandstone_slab": "sandsteinshella",
  "block.minecraft.cut_sandstone_slab": "skorin sandsteinshella",
  "block.minecraft.petrified_oak_slab": "steinrunnin eikarhella",
  "block.minecraft.cobblestone_slab": "grjóthella",
  "block.minecraft.brick_slab": "múrhella",
  "block.minecraft.stone_brick_slab": "steinmúrhella",
  "block.minecraft.nether_brick_slab": "heljarmúrsteinshella",
  "block.minecraft.quartz_slab": "kvarshella",
  "block.minecraft.red_sandstone_slab": "rauð sandsteinshella",
  "block.minecraft.cut_red_sandstone_slab": "skorin rauð sandsteinshella",
  "block.minecraft.purpur_slab": "purpurahella",
  "block.minecraft.prismarine_slab": "prismarínhella",
  "block.minecraft.prismarine_brick_slab": "prismarínmúrsteinshella",
  "block.minecraft.dark_prismarine_slab": "dökk prismarínhella",
  "block.minecraft.smooth_quartz": "sléttur kvarskubbur",
  "block.minecraft.smooth_red_sandstone": "sléttur rauður sandsteinn",
  "block.minecraft.smooth_sandstone": "sléttur sandsteinn",
  "block.minecraft.smooth_stone": "sléttur steinn",
  "block.minecraft.bricks": "múrsteinar",
  "block.minecraft.tnt": "sprengiefni",
  "block.minecraft.bookshelf": "bókahilla",
  "block.minecraft.mossy_cobblestone": "mosasteinn",
  "block.minecraft.obsidian": "hrafntinna",
  "block.minecraft.torch": "kyndill",
  "block.minecraft.end_rod": "end vegur",
  "block.minecraft.chorus_plant": "kór planta",
  "block.minecraft.chorus_flower": "kór blóm",
  "block.minecraft.purpur_block": "purpurakubbur",
  "block.minecraft.purpur_pillar": "purpurasúla",
  "block.minecraft.purpur_stairs": "purpuratröppur",
  "block.minecraft.spawner": "framkallari",
  "block.minecraft.oak_stairs": "eikartröppur",
  "block.minecraft.chest": "kista",
  "block.minecraft.diamond_ore": "demantsgrýti",
  "block.minecraft.diamond_block": "demantskubbur",
  "block.minecraft.crafting_table": "vinnubekkur",
  "block.minecraft.farmland": "ræktunarland",
  "block.minecraft.furnace": "ofn",
  "block.minecraft.ladder": "stigi",
  "block.minecraft.rail": "járnbraut",
  "block.minecraft.cobblestone_stairs": "steintröppur",
  "block.minecraft.lever": "rofi",
  "block.minecraft.stone_pressure_plate": "þrýstihella úr steini",
  "block.minecraft.oak_pressure_plate": "þrýstihella úr eik",
  "block.minecraft.spruce_pressure_plate": "þrýstihella úr greni",
  "block.minecraft.birch_pressure_plate": "þrýstihella úr birki",
  "block.minecraft.jungle_pressure_plate": "þrýstihella úr frumskógarviði",
  "block.minecraft.acacia_pressure_plate": "þrýstihella úr akasíu",
  "block.minecraft.dark_oak_pressure_plate": "þrýstihella úr dökkeik",
  "block.minecraft.crimson_pressure_plate": "hárauð þrýstihella",
  "block.minecraft.warped_pressure_plate": "brengluð þrýstihella",
  "block.minecraft.polished_blackstone_pressure_plate": "slípuð svartgrýtisþrýstihella",
  "block.minecraft.redstone_ore": "roðsteins grýti",
  "block.minecraft.redstone_torch": "rauðsteinskyndill",
  "block.minecraft.snow": "snjór",
  "block.minecraft.ice": "klaki",
  "block.minecraft.snow_block": "snjókubbur",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "leir",
  "block.minecraft.jukebox": "glymskratti",
  "block.minecraft.oak_fence": "eikargirðing",
  "block.minecraft.spruce_fence": "grenigirðing",
  "block.minecraft.birch_fence": "birkigirðing",
  "block.minecraft.jungle_fence": "frumskógargirðing",
  "block.minecraft.acacia_fence": "akasíugirðing",
  "block.minecraft.dark_oak_fence": "dökkeikargirðing",
  "block.minecraft.crimson_fence": "hárauð girðing",
  "block.minecraft.warped_fence": "brengluð girðing",
  "block.minecraft.pumpkin": "grasker",
  "block.minecraft.carved_pumpkin": "útskorið grasker",
  "block.minecraft.netherrack": "heljargrjót",
  "block.minecraft.soul_sand": "sálarsandur",
  "block.minecraft.soul_soil": "sálarmold",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "slípað basalt",
  "block.minecraft.soul_torch": "sálarkyndill",
  "block.minecraft.glowstone": "glósteinn",
  "block.minecraft.jack_o_lantern": "ljósker",
  "block.minecraft.oak_trapdoor": "eikarlúga",
  "block.minecraft.spruce_trapdoor": "grenihleri",
  "block.minecraft.birch_trapdoor": "birkilúga",
  "block.minecraft.jungle_trapdoor": "frumskógarviðarlúga",
  "block.minecraft.acacia_trapdoor": "akasíuhleri",
  "block.minecraft.dark_oak_trapdoor": "svarteikarhleri",
  "block.minecraft.crimson_trapdoor": "hárauð lúga",
  "block.minecraft.warped_trapdoor": "brenglaður hleri",
  "block.minecraft.infested_stone": "sýktur steinn",
  "block.minecraft.infested_cobblestone": "sýkt grjót",
  "block.minecraft.infested_stone_bricks": "sýktur steinmúr",
  "block.minecraft.infested_mossy_stone_bricks": "sýktur mosagróin steinmúr",
  "block.minecraft.infested_cracked_stone_bricks": "sýktur brotin steinmúr",
  "block.minecraft.infested_chiseled_stone_bricks": "sýktur meitlaður steinmúr",
  "block.minecraft.stone_bricks": "steinmúr",
  "block.minecraft.mossy_stone_bricks": "mosagróin steinhleðsla",
  "block.minecraft.cracked_stone_bricks": "brotin steinhleðsla",
  "block.minecraft.chiseled_stone_bricks": "útskorinn steinhleðsla",
  "block.minecraft.brown_mushroom_block": "brúnn sveppakubbur",
  "block.minecraft.red_mushroom_block": "rauður sveppakubbur",
  "block.minecraft.mushroom_stem": "sveppsfótur",
  "block.minecraft.iron_bars": "járnrimlar",
  "block.minecraft.chain": "keðja",
  "block.minecraft.glass_pane": "rúða",
  "block.minecraft.melon": "melóna",
  "block.minecraft.vine": "vínviður",
  "block.minecraft.oak_fence_gate": "eikarhlið",
  "block.minecraft.spruce_fence_gate": "grenihlið",
  "block.minecraft.birch_fence_gate": "birkihlið",
  "block.minecraft.jungle_fence_gate": "hlið úr frumskógarviði",
  "block.minecraft.acacia_fence_gate": "hlið úr akasíuviði",
  "block.minecraft.dark_oak_fence_gate": "dökkeikarhlið",
  "block.minecraft.crimson_fence_gate": "hárautt hlið",
  "block.minecraft.warped_fence_gate": "brenglað hlið",
  "block.minecraft.brick_stairs": "múrsteinströppur",
  "block.minecraft.stone_brick_stairs": "steinmúrströppur",
  "block.minecraft.mycelium": "svepparætur",
  "block.minecraft.lily_pad": "vatnalilja",
  "block.minecraft.nether_bricks": "heljarmúr",
  "block.minecraft.cracked_nether_bricks": "brotnir heljarmúrsteinar",
  "block.minecraft.chiseled_nether_bricks": "tilhöggnir heljarmúrsteinar",
  "block.minecraft.nether_brick_fence": "heljarmúrsgirðing",
  "block.minecraft.nether_brick_stairs": "heljarmúrsteinströppur",
  "block.minecraft.enchanting_table": "galdraborð",
  "block.minecraft.end_portal_frame": "endahliðsrammi",
  "block.minecraft.end_stone": "enda steinn",
  "block.minecraft.end_stone_bricks": "endasteinshleðsla",
  "block.minecraft.dragon_egg": "drekaegg",
  "block.minecraft.redstone_lamp": "rauðsteinslampi",
  "block.minecraft.sandstone_stairs": "sandsteinströppur",
  "block.minecraft.emerald_ore": "smaragðsgrýti",
  "block.minecraft.ender_chest": "enda kista",
  "block.minecraft.tripwire_hook": "vírkrækja",
  "block.minecraft.emerald_block": "smaragðskubbur",
  "block.minecraft.spruce_stairs": "grenitröppur",
  "block.minecraft.birch_stairs": "birkitröppur",
  "block.minecraft.jungle_stairs": "frumskógarviðartröppur",
  "block.minecraft.crimson_stairs": "hárauðar tröppur",
  "block.minecraft.warped_stairs": "brenglaðar tröppur",
  "block.minecraft.command_block": "forritunarkubbur",
  "block.minecraft.beacon": "geisli",
  "block.minecraft.cobblestone_wall": "steinveggur",
  "block.minecraft.mossy_cobblestone_wall": "mosasteinsveggur",
  "block.minecraft.brick_wall": "múrsteinsveggur",
  "block.minecraft.prismarine_wall": "prismarínveggur",
  "block.minecraft.red_sandstone_wall": "roðasandsteinsveggur",
  "block.minecraft.mossy_stone_brick_wall": "mosavaxin hleðslusteinsveggur",
  "block.minecraft.granite_wall": "granítveggur",
  "block.minecraft.stone_brick_wall": "hleðslusteinsveggur",
  "block.minecraft.nether_brick_wall": "heljarmúrsveggur",
  "block.minecraft.andesite_wall": "andesítveggur",
  "block.minecraft.red_nether_brick_wall": "rauður heljarmúrsveggur",
  "block.minecraft.sandstone_wall": "sandsteinsveggur",
  "block.minecraft.end_stone_brick_wall": "endasteinsveggur",
  "block.minecraft.diorite_wall": "díórítveggur",
  "block.minecraft.blackstone_wall": "svartgrýtismúr",
  "block.minecraft.polished_blackstone_wall": "slípaður svartgrýtismúr",
  "block.minecraft.polished_blackstone_brick_wall": "slípaður svartgrýtismúrsteinsmúr",
  "block.minecraft.stone_button": "steintakki",
  "block.minecraft.oak_button": "eikarhnappur",
  "block.minecraft.spruce_button": "grenihnappur",
  "block.minecraft.birch_button": "birkihnappur",
  "block.minecraft.jungle_button": "frumskógshnappur",
  "block.minecraft.acacia_button": "akasíuhnappur",
  "block.minecraft.dark_oak_button": "dökkur eikarhnappur",
  "block.minecraft.crimson_button": "hárauður hnappur",
  "block.minecraft.warped_button": "brenglaður hnappur",
  "block.minecraft.polished_blackstone_button": "slípaður svartgrýtishnappur",
  "block.minecraft.anvil": "steðji",
  "block.minecraft.chipped_anvil": "skaðaður steðji",
  "block.minecraft.damaged_anvil": "skemmdur steðji",
  "block.minecraft.trapped_chest": "gildrukista",
  "block.minecraft.light_weighted_pressure_plate": "létt þyngdarnæm þrýstihella",
  "block.minecraft.heavy_weighted_pressure_plate": "þung þyngdarnæm þrýstihella",
  "block.minecraft.daylight_detector": "ljósnemi",
  "block.minecraft.redstone_block": "rauðsteinskubbur",
  "block.minecraft.nether_quartz_ore": "heljarkvarsgrýti",
  "block.minecraft.hopper": "trekt",
  "block.minecraft.chiseled_quartz_block": "tilhöggvinn kvarskubbur",
  "block.minecraft.quartz_block": "kvarskubbur",
  "block.minecraft.quartz_bricks": "heljarkvarsmúr",
  "block.minecraft.quartz_pillar": "kvarssúla",
  "block.minecraft.quartz_stairs": "kvarströppur",
  "block.minecraft.activator_rail": "kveikjuteinn",
  "block.minecraft.dropper": "sleppir",
  "block.minecraft.white_terracotta": "hvítt keramik",
  "block.minecraft.orange_terracotta": "appelnsínugult keramik",
  "block.minecraft.magenta_terracotta": "vínrautt keramik",
  "block.minecraft.light_blue_terracotta": "ljósblátt keramik",
  "block.minecraft.yellow_terracotta": "gult keramik",
  "block.minecraft.lime_terracotta": "ljósgrænt keramik",
  "block.minecraft.pink_terracotta": "bleikt keramik",
  "block.minecraft.gray_terracotta": "grátt keramik",
  "block.minecraft.light_gray_terracotta": "ljósgrátt keramik",
  "block.minecraft.cyan_terracotta": "heiðblá keramik",
  "block.minecraft.purple_terracotta": "fjólublátt keramik",
  "block.minecraft.blue_terracotta": "blátt keramik",
  "block.minecraft.brown_terracotta": "brúnt keramik",
  "block.minecraft.green_terracotta": "grænt keramik",
  "block.minecraft.red_terracotta": "rautt keramik",
  "block.minecraft.black_terracotta": "svart keramik",
  "block.minecraft.barrier": "hlið",
  "block.minecraft.iron_trapdoor": "járnlúga",
  "block.minecraft.hay_block": "heybaggi",
  "block.minecraft.white_carpet": "hvítt gólfteppi",
  "block.minecraft.orange_carpet": "appelsínugult gólfteppi",
  "block.minecraft.magenta_carpet": "vínrautt gólfteppi",
  "block.minecraft.light_blue_carpet": "ljósblátt gólfteppi",
  "block.minecraft.yellow_carpet": "gult teppi",
  "block.minecraft.lime_carpet": "ljósgrænt gólfteppi",
  "block.minecraft.pink_carpet": "bleikt gólfteppi",
  "block.minecraft.gray_carpet": "grátt gólfteppi",
  "block.minecraft.light_gray_carpet": "ljósgrátt gólfteppi",
  "block.minecraft.cyan_carpet": "heiðblátt gólfteppi",
  "block.minecraft.purple_carpet": "fjólublátt gólfteppi",
  "block.minecraft.blue_carpet": "blátt gólfteppi",
  "block.minecraft.brown_carpet": "brúnt gólfteppi",
  "block.minecraft.green_carpet": "grænt gólfteppi",
  "block.minecraft.red_carpet": "rautt gólfteppi",
  "block.minecraft.black_carpet": "svart gólfteppi",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "kolakubbur",
  "block.minecraft.packed_ice": "þjappaður ís",
  "block.minecraft.acacia_stairs": "akasíutröppur",
  "block.minecraft.dark_oak_stairs": "dökkeikartröppur",
  "block.minecraft.slime_block": "slímkubbur",
  "block.minecraft.grass_path": "grasstígur",
  "block.minecraft.sunflower": "sólblóm",
  "block.minecraft.lilac": "sýrena",
  "block.minecraft.rose_bush": "rósarunni",
  "block.minecraft.peony": "bóndarós",
  "block.minecraft.tall_grass": "hátt gras",
  "block.minecraft.large_fern": "stór runni",
  "block.minecraft.white_stained_glass": "hvítt litað gler",
  "block.minecraft.orange_stained_glass": "appelsínugult gler",
  "block.minecraft.magenta_stained_glass": "vínrautt litað gler",
  "block.minecraft.light_blue_stained_glass": "ljós blátt litað gler",
  "block.minecraft.yellow_stained_glass": "gul litað gler",
  "block.minecraft.lime_stained_glass": "ljósgrænt litað gler",
  "block.minecraft.pink_stained_glass": "bleikt litað gler",
  "block.minecraft.gray_stained_glass": "grátt litað gler",
  "block.minecraft.light_gray_stained_glass": "ljós grátt litað gler",
  "block.minecraft.cyan_stained_glass": "heiðblátt gler",
  "block.minecraft.purple_stained_glass": "fjólublátt litað gler",
  "block.minecraft.blue_stained_glass": "blálitað gler",
  "block.minecraft.brown_stained_glass": "brúnlitt gler",
  "block.minecraft.green_stained_glass": "grænlitað gler",
  "block.minecraft.red_stained_glass": "rauð litað gler",
  "block.minecraft.black_stained_glass": "svart litað gler",
  "block.minecraft.white_stained_glass_pane": "litað hvítt gler",
  "block.minecraft.orange_stained_glass_pane": "litað appelsínugult gler",
  "block.minecraft.magenta_stained_glass_pane": "vínrauð lituð rúða",
  "block.minecraft.light_blue_stained_glass_pane": "litað ljósblátt gler",
  "block.minecraft.yellow_stained_glass_pane": "lituð gul rúða",
  "block.minecraft.lime_stained_glass_pane": "ljósgræn rúða",
  "block.minecraft.pink_stained_glass_pane": "lituð bleik rúða",
  "block.minecraft.gray_stained_glass_pane": "lituð grá rúða",
  "block.minecraft.light_gray_stained_glass_pane": "lituð ljós grá rúða",
  "block.minecraft.cyan_stained_glass_pane": "heiðblá rúða",
  "block.minecraft.purple_stained_glass_pane": "fjólublá rúða",
  "block.minecraft.blue_stained_glass_pane": "lituð blá rúða",
  "block.minecraft.brown_stained_glass_pane": "lituð brún rúða",
  "block.minecraft.green_stained_glass_pane": "lituð græn rúða",
  "block.minecraft.red_stained_glass_pane": "lituð rauð rúða",
  "block.minecraft.black_stained_glass_pane": "svört lituð rúða",
  "block.minecraft.prismarine": "prismarín",
  "block.minecraft.prismarine_bricks": "prismarín múrsteinar",
  "block.minecraft.dark_prismarine": "dökkt prismarín",
  "block.minecraft.prismarine_stairs": "prismaríntröppur",
  "block.minecraft.prismarine_brick_stairs": "prismarínmúrsteinströppur",
  "block.minecraft.dark_prismarine_stairs": "dökkar prismaríntröppur",
  "block.minecraft.sea_lantern": "haflukt",
  "block.minecraft.red_sandstone": "rauður sandsteinn",
  "block.minecraft.chiseled_red_sandstone": "meitlaður rauður sandsteinn",
  "block.minecraft.cut_red_sandstone": "skorinn rauður sandsteinn",
  "block.minecraft.red_sandstone_stairs": "rauðar sandsteinströppur",
  "block.minecraft.repeating_command_block": "endurtakandi forritunarkubbur",
  "block.minecraft.chain_command_block": "raðforritunarkubbur",
  "block.minecraft.magma_block": "kvikukubbur",
  "block.minecraft.nether_wart_block": "heljarvörtukubbur",
  "block.minecraft.warped_wart_block": "brenglaður heljarvörtukubbur",
  "block.minecraft.red_nether_bricks": "rauður heljarmúr",
  "block.minecraft.bone_block": "beinakubbur",
  "block.minecraft.structure_void": "tómarúms bygging",
  "block.minecraft.observer": "skynjari",
  "block.minecraft.shulker_box": "hylki skálks",
  "block.minecraft.white_shulker_box": "hvítt hylki skálks",
  "block.minecraft.orange_shulker_box": "appelsínugult hylki skálks",
  "block.minecraft.magenta_shulker_box": "vínrautt hylki skálks",
  "block.minecraft.light_blue_shulker_box": "ljósblátt hylki skálks",
  "block.minecraft.yellow_shulker_box": "gult hylki skálks",
  "block.minecraft.lime_shulker_box": "ljósgrænt hylki skálks",
  "block.minecraft.pink_shulker_box": "bleikt hylki skálks",
  "block.minecraft.gray_shulker_box": "grátt hylki skálks",
  "block.minecraft.light_gray_shulker_box": "ljósgrátt hylki skálks",
  "block.minecraft.cyan_shulker_box": "blágrænt hylki skálks",
  "block.minecraft.purple_shulker_box": "fjólublátt hylki skálks",
  "block.minecraft.blue_shulker_box": "blátt hylki skálks",
  "block.minecraft.brown_shulker_box": "brúnt hylki skálks",
  "block.minecraft.green_shulker_box": "grænt hylki skálks",
  "block.minecraft.red_shulker_box": "rautt hylki skálks",
  "block.minecraft.black_shulker_box": "svart hylki skálks",
  "block.minecraft.white_glazed_terracotta": "hvítur glerjaður brenndur leir",
  "block.minecraft.orange_glazed_terracotta": "appelsínugulur glerjaður brenndur leir",
  "block.minecraft.magenta_glazed_terracotta": "vínrautt glerjað keramík",
  "block.minecraft.light_blue_glazed_terracotta": "ljósblár glerjaður brenndur leir",
  "block.minecraft.yellow_glazed_terracotta": "gulur glerjaður brenndur leir",
  "block.minecraft.lime_glazed_terracotta": "ljósgrænn glerjaður brenndur leir",
  "block.minecraft.pink_glazed_terracotta": "bleikur glerjaður brenndur leir",
  "block.minecraft.gray_glazed_terracotta": "grár glerjaður brenndur leir",
  "block.minecraft.light_gray_glazed_terracotta": "ljósgrár glerjaður brenndur leir",
  "block.minecraft.cyan_glazed_terracotta": "blágrænn glerjaður brenndur leir",
  "block.minecraft.purple_glazed_terracotta": "fjólublár glerjaður brenndur leir",
  "block.minecraft.blue_glazed_terracotta": "blár glerjaður brenndur leir",
  "block.minecraft.brown_glazed_terracotta": "brúnn glerjaður brenndur leir",
  "block.minecraft.green_glazed_terracotta": "grænn glerjaður brenndur leir",
  "block.minecraft.red_glazed_terracotta": "rauður glerjaður brenndur leir",
  "block.minecraft.black_glazed_terracotta": "svartur glerjaður brenndur leir",
  "block.minecraft.white_concrete": "hvít steinsteypa",
  "block.minecraft.orange_concrete": "appelsínugul steinsteypa",
  "block.minecraft.magenta_concrete": "vínrauð steinsteypa",
  "block.minecraft.light_blue_concrete": "ljósblá steinsteypa",
  "block.minecraft.yellow_concrete": "gul steinsteypa",
  "block.minecraft.lime_concrete": "ljósgræn steinsteypa",
  "block.minecraft.pink_concrete": "bleik steinsteypa",
  "block.minecraft.gray_concrete": "grá steinsteypa",
  "block.minecraft.light_gray_concrete": "ljósgrá steinsteypa",
  "block.minecraft.cyan_concrete": "blágræn steinsteypa",
  "block.minecraft.purple_concrete": "fjólublá steinsteypa",
  "block.minecraft.blue_concrete": "blá steinsteypa",
  "block.minecraft.brown_concrete": "brún steinsteypa",
  "block.minecraft.green_concrete": "græn steinsteypa",
  "block.minecraft.red_concrete": "rauð steinsteypa",
  "block.minecraft.black_concrete": "svört steinsteypa",
  "block.minecraft.white_concrete_powder": "hvítt sement",
  "block.minecraft.orange_concrete_powder": "appelsínugult sement",
  "block.minecraft.magenta_concrete_powder": "vínrautt sement",
  "block.minecraft.light_blue_concrete_powder": "ljósblátt sement",
  "block.minecraft.yellow_concrete_powder": "gult sement",
  "block.minecraft.lime_concrete_powder": "ljósgrænt sement",
  "block.minecraft.pink_concrete_powder": "bleikt sement",
  "block.minecraft.gray_concrete_powder": "grátt sement",
  "block.minecraft.light_gray_concrete_powder": "ljósgrátt sement",
  "block.minecraft.cyan_concrete_powder": "blágrænt sement",
  "block.minecraft.purple_concrete_powder": "fjólublátt sement",
  "block.minecraft.blue_concrete_powder": "blátt sement",
  "block.minecraft.brown_concrete_powder": "brúnt sement",
  "block.minecraft.green_concrete_powder": "grænt sement",
  "block.minecraft.red_concrete_powder": "rautt sement",
  "block.minecraft.black_concrete_powder": "svart sement",
  "block.minecraft.turtle_egg": "skjaldböku egg",
  "block.minecraft.dead_tube_coral_block": "dauður pípukóralskubbur",
  "block.minecraft.dead_brain_coral_block": "dauður heilakóralskubbur",
  "block.minecraft.dead_bubble_coral_block": "dauður kúlukóralskubbur",
  "block.minecraft.dead_fire_coral_block": "dauður funakóralskubbur",
  "block.minecraft.dead_horn_coral_block": "dauður hornkóralskubbur",
  "block.minecraft.tube_coral_block": "pípukóralskubbur",
  "block.minecraft.brain_coral_block": "heilakóralskubbur",
  "block.minecraft.bubble_coral_block": "kúlukóralskubbur",
  "block.minecraft.fire_coral_block": "funakóralskubbur",
  "block.minecraft.horn_coral_block": "hornakóralskubbur",
  "block.minecraft.tube_coral": "pípukórall",
  "block.minecraft.brain_coral": "heilakórall",
  "block.minecraft.bubble_coral": "kúlukórall",
  "block.minecraft.fire_coral": "funakórall",
  "block.minecraft.horn_coral": "hornakórall",
  "block.minecraft.dead_brain_coral": "dauður heilakórall",
  "block.minecraft.dead_bubble_coral": "dauður kúlukórall",
  "block.minecraft.dead_fire_coral": "dauður funakórall",
  "block.minecraft.dead_horn_coral": "dauður hornakórall",
  "block.minecraft.dead_tube_coral": "dauður pípukórall",
  "block.minecraft.tube_coral_fan": "pípukóralsvængur",
  "block.minecraft.brain_coral_fan": "heilakóralsvængur",
  "block.minecraft.bubble_coral_fan": "kúlukóralsvængur",
  "block.minecraft.fire_coral_fan": "funakóralsvængur",
  "block.minecraft.horn_coral_fan": "hornakóralsvængur",
  "block.minecraft.dead_tube_coral_fan": "dauður pípukóralsvængur",
  "block.minecraft.dead_brain_coral_fan": "dauður heilakóralsvængur",
  "block.minecraft.dead_bubble_coral_fan": "dauður kúlukóralsvængur",
  "block.minecraft.dead_fire_coral_fan": "dauður funakóralsvængur",
  "block.minecraft.dead_horn_coral_fan": "dauður hornakóralsvængur",
  "block.minecraft.blue_ice": "blár ís",
  "block.minecraft.conduit": "flæðari",
  "block.minecraft.polished_granite_stairs": "slípaðar graníttröppur",
  "block.minecraft.smooth_red_sandstone_stairs": "sléttar roðasandsteinströppur",
  "block.minecraft.mossy_stone_brick_stairs": "mosavaxnar hleðslusteinströppur",
  "block.minecraft.polished_diorite_stairs": "slípaðar díóríttröppur",
  "block.minecraft.mossy_cobblestone_stairs": "mosavaxnar götusteinströppur",
  "block.minecraft.end_stone_brick_stairs": "endasteinströppur",
  "block.minecraft.stone_stairs": "steintröppur",
  "block.minecraft.smooth_sandstone_stairs": "sléttar sandsteinströppur",
  "block.minecraft.smooth_quartz_stairs": "sléttar kvarströppur",
  "block.minecraft.granite_stairs": "graníttröppur",
  "block.minecraft.andesite_stairs": "andesíttröppur",
  "block.minecraft.red_nether_brick_stairs": "rauðar heljarmúrströppur",
  "block.minecraft.polished_andesite_stairs": "slípaðar andesíttröppur",
  "block.minecraft.diorite_stairs": "díóríttröppur",
  "block.minecraft.polished_granite_slab": "slípuð graníthella",
  "block.minecraft.smooth_red_sandstone_slab": "sléttar roðasandsteinshella",
  "block.minecraft.mossy_stone_brick_slab": "mosavaxin hleðslusteinshella",
  "block.minecraft.polished_diorite_slab": "slípuð díóríthella",
  "block.minecraft.mossy_cobblestone_slab": "mosavaxin götusteinshella",
  "block.minecraft.end_stone_brick_slab": "endasteinshella",
  "block.minecraft.smooth_sandstone_slab": "slétt sandsteinshella",
  "block.minecraft.smooth_quartz_slab": "slétt kvarshella",
  "block.minecraft.granite_slab": "graníthella",
  "block.minecraft.andesite_slab": "andesíthella",
  "block.minecraft.red_nether_brick_slab": "rauð heljarmúrshella",
  "block.minecraft.polished_andesite_slab": "slípuð andesíthella",
  "block.minecraft.diorite_slab": "díóríthella",
  "block.minecraft.scaffolding": "stillans",
  "block.minecraft.iron_door": "járnhurð",
  "block.minecraft.oak_door": "eikarhurð",
  "block.minecraft.spruce_door": "grenihurð",
  "block.minecraft.birch_door": "birkihurð",
  "block.minecraft.jungle_door": "frumskógarviðshurð",
  "block.minecraft.acacia_door": "akasíuviðarhurð",
  "block.minecraft.dark_oak_door": "dökkeikarhurð",
  "block.minecraft.crimson_door": "hárauð hurð",
  "block.minecraft.warped_door": "brengluð hurð",
  "block.minecraft.repeater": "roðsteinsmagnari",
  "block.minecraft.comparator": "samanburðarrofi",
  "block.minecraft.structure_block": "byggingarkubbur",
  "block.minecraft.jigsaw": "púsluspilskubbur",
  "item.minecraft.turtle_helmet": "skjaldbökuskel□□hvenær á höfði:□+2 brynja",
  "item.minecraft.scute": "hreistur",
  "item.minecraft.iron_shovel": "járnskófla□□þegar hún er í helstu hönd:□+3.5 árásar skaði□-3 árásarhraði",
  "item.minecraft.iron_pickaxe": "járnhaki□□þegar hún er í helstu hönd:□+3 árásar skaði□-2.8 árásarhraði",
  "item.minecraft.iron_axe": "járnöxi□□þegar hún er í helstu hönd:□+8 árásar skaði□-3.1 árásarhraði",
  "item.minecraft.flint_and_steel": "tinna og stál",
  "item.minecraft.apple": "epli",
  "item.minecraft.bow": "bogi",
  "item.minecraft.arrow": "ör",
  "item.minecraft.coal": "kol",
  "item.minecraft.charcoal": "viðarkol",
  "item.minecraft.diamond": "demantur",
  "item.minecraft.iron_ingot": "járnhleifur",
  "item.minecraft.gold_ingot": "gullhleifur",
  "item.minecraft.netherite_ingot": "heljarmálmshleifur",
  "item.minecraft.netherite_scrap": "heljarmálmsbrot",
  "item.minecraft.iron_sword": "járnsverð□□þegar hún er í helstu hönd:□+5 árásar skaði□-2.4 árásarhraði",
  "item.minecraft.wooden_sword": "viðarsverð□□þegar hún er í helstu hönd:□+3 árásar skaði□-2.4 árásarhraði",
  "item.minecraft.wooden_shovel": "viðarskófla□□þegar hún er í helstu hönd:□+1.5 árásar skaði□-3 árásarhraði",
  "item.minecraft.wooden_pickaxe": "viðarhaki□□þegar hún er í helstu hönd:□+1 árásar skaði□-2.8 árásarhraði",
  "item.minecraft.wooden_axe": "viðaröxi□□þegar hún er í helstu hönd:□+6 árásar skaði□-3.2 árásarhraði",
  "item.minecraft.stone_sword": "steinsverð□□þegar hún er í helstu hönd:□+4 árásar skaði□-2.4 árásarhraði",
  "item.minecraft.stone_shovel": "steinskófla□□þegar hún er í helstu hönd:□+2.5 árásar skaði□-3 árásarhraði",
  "item.minecraft.stone_pickaxe": "steinhaki□□þegar hún er í helstu hönd:□+2 árásar skaði□-2.8 árásarhraði",
  "item.minecraft.stone_axe": "steinöxi□□þegar hún er í helstu hönd:□+8 árásar skaði□-3.2 árásarhraði",
  "item.minecraft.diamond_sword": "demantssverð□□þegar hún er í helstu hönd:□+6 árásar skaði□-2.4 árásarhraði",
  "item.minecraft.diamond_shovel": "demantsskófla□□þegar hún er í helstu hönd:□+4.5 árásar skaði□-3 árásarhraði",
  "item.minecraft.diamond_pickaxe": "demantshaki□□þegar hún er í helstu hönd:□+4 árásar skaði□-2.8 árásarhraði",
  "item.minecraft.diamond_axe": "demantsöxi□□þegar hún er í helstu hönd:□+8 árásar skaði□-3 árásarhraði",
  "item.minecraft.stick": "prik",
  "item.minecraft.bowl": "skál",
  "item.minecraft.mushroom_stew": "sveppasúpa",
  "item.minecraft.golden_sword": "gullsverð□□þegar hún er í helstu hönd:□+3 árásar skaði□-2.4 árásarhraði",
  "item.minecraft.golden_shovel": "gullskófla□□þegar hún er í helstu hönd:□+1.5 árásar skaði□-3 árásarhraði",
  "item.minecraft.golden_pickaxe": "gullhaki□□þegar hún er í helstu hönd:□+1 árásar skaði□-2.8 árásarhraði",
  "item.minecraft.golden_axe": "gullöxi□□þegar hún er í helstu hönd:□+6 árásar skaði□-3 árásarhraði",
  "item.minecraft.netherite_sword": "heljarmálmssverð□□þegar hún er í helstu hönd:□+7 árásar skaði□-2.4 árásarhraði",
  "item.minecraft.netherite_shovel": "heljarmálmsskófla□□þegar hún er í helstu hönd:□+5.5 árásar skaði□-3 árásarhraði",
  "item.minecraft.netherite_pickaxe": "heljarmálmshaki□□þegar hún er í helstu hönd:□+5 árásar skaði□-2.8 árásarhraði",
  "item.minecraft.netherite_axe": "heljarmálmsöxi□□þegar hún er í helstu hönd:□+9 árásar skaði□-3 árásarhraði",
  "item.minecraft.string": "snæri",
  "item.minecraft.feather": "fjöður",
  "item.minecraft.gunpowder": "byssupúður",
  "item.minecraft.wooden_hoe": "viðarhlújárn□□þegar hún er í helstu hönd:□-3 árásarhraði",
  "item.minecraft.stone_hoe": "steinhlújárn□□þegar hún er í helstu hönd:□-2 árásarhraði",
  "item.minecraft.iron_hoe": "járnhlújárn□□þegar hún er í helstu hönd:□-1 árásarhraði",
  "item.minecraft.diamond_hoe": "demantshlújárn□□þegar hún er í helstu hönd:",
  "item.minecraft.golden_hoe": "gullhlújárn□□þegar hún er í helstu hönd:□-3 árásarhraði",
  "item.minecraft.netherite_hoe": "heljarmálmshlújárn□□þegar hún er í helstu hönd:",
  "item.minecraft.wheat_seeds": "hveitifræ",
  "item.minecraft.wheat": "hveiti",
  "item.minecraft.bread": "brauð",
  "item.minecraft.leather_helmet": "leðurhattur□□hvenær á höfði:□+1 brynja",
  "item.minecraft.leather_chestplate": "leðurjakki□□hvenær á líkamanum:□+3 brynja",
  "item.minecraft.leather_leggings": "leðurbuxur□□þegar á fótum:□+2 brynja",
  "item.minecraft.leather_boots": "leðurstígvél□□hvenær á fætur:□+1 brynja",
  "item.minecraft.chainmail_helmet": "hringabrynjuhjálmur□□hvenær á höfði:□+2 brynja",
  "item.minecraft.chainmail_chestplate": "hringabrynja□□hvenær á líkamanum:□+5 brynja",
  "item.minecraft.chainmail_leggings": "hringabrynjuhosur□□þegar á fótum:□+4 brynja",
  "item.minecraft.chainmail_boots": "hringabrynjustígvél□□hvenær á fætur:□+1 brynja",
  "item.minecraft.iron_helmet": "járnhjálmur□□hvenær á höfði:□+2 brynja",
  "item.minecraft.iron_chestplate": "járnbrynja□□hvenær á líkamanum:□+6 brynja",
  "item.minecraft.iron_leggings": "járnlegghlífar□□þegar á fótum:□+5 brynja",
  "item.minecraft.iron_boots": "járnstígvél□□hvenær á fætur:□+2 brynja",
  "item.minecraft.diamond_helmet": "demantshjálmur□□hvenær á höfði:□+3 brynja□+2 styrkleiki brynju",
  "item.minecraft.diamond_chestplate": "demantsbrynja□□hvenær á líkamanum:□+8 brynja□+2 styrkleiki brynju",
  "item.minecraft.diamond_leggings": "demantslegghlífar□□þegar á fótum:□+6 brynja□+2 styrkleiki brynju",
  "item.minecraft.diamond_boots": "demantsstígvél□□hvenær á fætur:□+3 brynja□+2 styrkleiki brynju",
  "item.minecraft.golden_helmet": "gullhjálmur□□hvenær á höfði:□+2 brynja",
  "item.minecraft.golden_chestplate": "gullbrynja□□hvenær á líkamanum:□+5 brynja",
  "item.minecraft.golden_leggings": "gulllegghlífar□□þegar á fótum:□+3 brynja",
  "item.minecraft.golden_boots": "gullstígvél□□hvenær á fætur:□+1 brynja",
  "item.minecraft.netherite_helmet": "heljarmálmshjálmur□□hvenær á höfði:□+3 brynja□+3 styrkleiki brynju□+1 afturkasts vörn",
  "item.minecraft.netherite_chestplate": "heljarmálmsbrynja□□hvenær á líkamanum:□+8 brynja□+3 styrkleiki brynju□+1 afturkasts vörn",
  "item.minecraft.netherite_leggings": "heljarmálmslegghlífar□□þegar á fótum:□+6 brynja□+3 styrkleiki brynju□+1 afturkasts vörn",
  "item.minecraft.netherite_boots": "heljarmálmsstígvél□□hvenær á fætur:□+3 brynja□+3 styrkleiki brynju□+1 afturkasts vörn",
  "item.minecraft.flint": "tinna",
  "item.minecraft.porkchop": "hrátt svínakjöt",
  "item.minecraft.cooked_porkchop": "eldað svínakjöt",
  "item.minecraft.painting": "málverk",
  "item.minecraft.golden_apple": "gullepli",
  "item.minecraft.enchanted_golden_apple": "galdragullepli",
  "block.minecraft.oak_sign": "eikarskilti",
  "block.minecraft.spruce_sign": "greniskilti",
  "block.minecraft.birch_sign": "birkiskilti",
  "block.minecraft.jungle_sign": "frumskógarviðsskilti",
  "block.minecraft.acacia_sign": "akasíuskilti",
  "block.minecraft.dark_oak_sign": "dökkt eikarskilti",
  "block.minecraft.crimson_sign": "hárautt skilti",
  "block.minecraft.warped_sign": "brenglað skilti",
  "item.minecraft.bucket": "fata",
  "item.minecraft.water_bucket": "vatnsfata",
  "item.minecraft.lava_bucket": "hraunfata",
  "item.minecraft.minecart": "námuvagn",
  "item.minecraft.saddle": "hnakkur",
  "item.minecraft.redstone": "roðsteinsduft",
  "item.minecraft.snowball": "snjóbolti",
  "item.minecraft.oak_boat": "eikarbátur",
  "item.minecraft.leather": "leður",
  "item.minecraft.milk_bucket": "mjólkurfata",
  "item.minecraft.pufferfish_bucket": "fata með kúlufisk",
  "item.minecraft.salmon_bucket": "fata með laxi",
  "item.minecraft.cod_bucket": "fata með þorski",
  "item.minecraft.tropical_fish_bucket": "hitabeltisfiskur í fötu",
  "item.minecraft.brick": "múrsteinn",
  "item.minecraft.clay_ball": "leirkúla",
  "block.minecraft.dried_kelp_block": "þurrkaður þarakubbur",
  "item.minecraft.paper": "blað",
  "item.minecraft.book": "bók",
  "item.minecraft.slime_ball": "slímbolti",
  "item.minecraft.chest_minecart": "námuvagn með kistu",
  "item.minecraft.furnace_minecart": "námuvagn með ofni",
  "item.minecraft.egg": "egg",
  "item.minecraft.compass": "áttaviti",
  "item.minecraft.fishing_rod": "veiðistöng",
  "item.minecraft.clock": "klukka",
  "item.minecraft.glowstone_dust": "glósteinsduft",
  "item.minecraft.cod": "hrár þorskur",
  "item.minecraft.salmon": "hrár lax",
  "item.minecraft.tropical_fish": "hitabeltisfiskur",
  "item.minecraft.pufferfish": "kúlufiskur",
  "item.minecraft.cooked_cod": "eldaður þorskur",
  "item.minecraft.cooked_salmon": "eldaður lax",
  "item.minecraft.ink_sac": "bleksekkur",
  "item.minecraft.red_dye": "rautt litarefni",
  "item.minecraft.green_dye": "grænt litarefni",
  "item.minecraft.cocoa_beans": "kakóbaunir",
  "item.minecraft.lapis_lazuli": "asúrsteinn",
  "item.minecraft.purple_dye": "fjólublár liltur",
  "item.minecraft.cyan_dye": "lillablár litur",
  "item.minecraft.light_gray_dye": "ljósgrár litur",
  "item.minecraft.gray_dye": "grár litur",
  "item.minecraft.pink_dye": "bleikur litur",
  "item.minecraft.lime_dye": "ljósgrænn litur",
  "item.minecraft.yellow_dye": "gult litarefni",
  "item.minecraft.light_blue_dye": "ljósblár litur",
  "item.minecraft.magenta_dye": "vínrauður litur",
  "item.minecraft.orange_dye": "appelsínugulur litur",
  "item.minecraft.bone_meal": "beinamjöl",
  "item.minecraft.blue_dye": "blátt litarefni",
  "item.minecraft.brown_dye": "brúnt litarefni",
  "item.minecraft.black_dye": "svart litarefni",
  "item.minecraft.white_dye": "hvítt litarefni",
  "item.minecraft.bone": "bein",
  "item.minecraft.sugar": "sykur",
  "block.minecraft.cake": "kaka",
  "block.minecraft.white_bed": "hvítt rúm",
  "block.minecraft.orange_bed": "appelsínugult rúm",
  "block.minecraft.magenta_bed": "vínrautt rúm",
  "block.minecraft.light_blue_bed": "ljósblátt rúm",
  "block.minecraft.yellow_bed": "gult rúm",
  "block.minecraft.lime_bed": "ljósgrænt rúm",
  "block.minecraft.pink_bed": "bleikt rúm",
  "block.minecraft.gray_bed": "grátt rúm",
  "block.minecraft.light_gray_bed": "ljósgrátt rúm",
  "block.minecraft.cyan_bed": "heiðblátt rúm",
  "block.minecraft.purple_bed": "fjólublátt rúm",
  "block.minecraft.blue_bed": "blátt rúm",
  "block.minecraft.brown_bed": "brúnt rúm",
  "block.minecraft.green_bed": "grænt rúm",
  "block.minecraft.red_bed": "rautt rúm",
  "block.minecraft.black_bed": "svart rúm",
  "item.minecraft.cookie": "smákaka",
  "item.minecraft.filled_map": "kort□#0",
  "item.minecraft.shears": "klippur",
  "item.minecraft.melon_slice": "melónusneið",
  "item.minecraft.dried_kelp": "þurkað þang",
  "item.minecraft.pumpkin_seeds": "graskersfræ",
  "item.minecraft.melon_seeds": "melónufræ",
  "item.minecraft.beef": "hrátt nautakjöt",
  "item.minecraft.cooked_beef": "nautasteik",
  "item.minecraft.chicken": "hrár kjúklingur",
  "item.minecraft.cooked_chicken": "eldaður kjúklingur",
  "item.minecraft.rotten_flesh": "rotið hold",
  "item.minecraft.ender_pearl": "enda perla",
  "item.minecraft.blaze_rod": "logateinn",
  "item.minecraft.ghast_tear": "draugatár",
  "item.minecraft.gold_nugget": "gullmoli",
  "item.minecraft.nether_wart": "heljarvarta",
  "item.minecraft.potion": "ósmíðanlegt seyði□engin áhrif",
  "item.minecraft.glass_bottle": "flaska",
  "item.minecraft.spider_eye": "köngulóarauga",
  "item.minecraft.fermented_spider_eye": "kæst köngulóarauga",
  "item.minecraft.blaze_powder": "logaduft",
  "item.minecraft.magma_cream": "kvikukrem",
  "block.minecraft.brewing_stand": "bruggstöð",
  "block.minecraft.cauldron": "seiðpottur",
  "item.minecraft.ender_eye": "endaauga",
  "item.minecraft.glistering_melon_slice": "glitrandi melónusneið",
  "item.minecraft.bat_spawn_egg": "leðurblöku framköllunaregg",
  "item.minecraft.bee_spawn_egg": "býflugu framköllunaregg",
  "item.minecraft.blaze_spawn_egg": "loga framköllunaregg",
  "item.minecraft.cat_spawn_egg": "kattar framköllunaregg",
  "item.minecraft.cave_spider_spawn_egg": "hellaköngulóar framköllunaregg",
  "item.minecraft.chicken_spawn_egg": "hænu framköllunaregg",
  "item.minecraft.cod_spawn_egg": "þorsks framköllunaregg",
  "item.minecraft.cow_spawn_egg": "kýr framköllunaregg",
  "item.minecraft.creeper_spawn_egg": "laumupúka framköllunaregg",
  "item.minecraft.dolphin_spawn_egg": "höfrungs framköllunaregg",
  "item.minecraft.donkey_spawn_egg": "asna framköllunaregg",
  "item.minecraft.drowned_spawn_egg": "druknaðs uppvaknings framköllunaregg",
  "item.minecraft.elder_guardian_spawn_egg": "öldungarverndara framköllunaregg",
  "item.minecraft.enderman_spawn_egg": "endamanns framköllunaregg",
  "item.minecraft.endermite_spawn_egg": "endamaurs framköllunaregg",
  "item.minecraft.evoker_spawn_egg": "kraftaskáldsspunaegg",
  "item.minecraft.fox_spawn_egg": "refs framköllunaregg",
  "item.minecraft.ghast_spawn_egg": "voms framköllunaregg",
  "item.minecraft.guardian_spawn_egg": "verndara framköllunaregg",
  "item.minecraft.hoglin_spawn_egg": "göltungs framköllunaregg",
  "item.minecraft.horse_spawn_egg": "hesta framköllunaregg",
  "item.minecraft.husk_spawn_egg": "nás framköllunaregg",
  "item.minecraft.llama_spawn_egg": "lamadýrs framköllunaregg",
  "item.minecraft.magma_cube_spawn_egg": "kvikukubbs framköllunaregg",
  "item.minecraft.mooshroom_spawn_egg": "sveppakúar framköllunaregg",
  "item.minecraft.mule_spawn_egg": "múlasna framköllunaregg",
  "item.minecraft.ocelot_spawn_egg": "villikattar framköllunaregg",
  "item.minecraft.panda_spawn_egg": "pöndu framköllunaregg",
  "item.minecraft.parrot_spawn_egg": "páfagauks framköllunaregg",
  "item.minecraft.phantom_spawn_egg": "vofu framköllunaregg",
  "item.minecraft.pig_spawn_egg": "svíns framköllunaregg",
  "item.minecraft.piglin_spawn_egg": "svínungs framköllunaregg",
  "item.minecraft.pillager_spawn_egg": "ruplara framköllunaregg",
  "item.minecraft.polar_bear_spawn_egg": "ísbjarnar framköllunaregg",
  "item.minecraft.pufferfish_spawn_egg": "kúlufisks framköllunaregg",
  "item.minecraft.rabbit_spawn_egg": "kanínu framköllunaregg",
  "item.minecraft.ravager_spawn_egg": "rústara framköllunaregg",
  "item.minecraft.salmon_spawn_egg": "lax framköllunaregg",
  "item.minecraft.sheep_spawn_egg": "kindar framköllunaregg",
  "item.minecraft.shulker_spawn_egg": "framköllunaregg skálks",
  "item.minecraft.silverfish_spawn_egg": "silfurskottu framköllunaregg",
  "item.minecraft.skeleton_spawn_egg": "beinagrindar framköllunaregg",
  "item.minecraft.skeleton_horse_spawn_egg": "beinagands framköllunaregg",
  "item.minecraft.slime_spawn_egg": "slím framköllunaregg",
  "item.minecraft.spider_spawn_egg": "köngulóar framköllunaregg",
  "item.minecraft.squid_spawn_egg": "smokkfisks framköllunaregg",
  "item.minecraft.stray_spawn_egg": "frávillings framköllunaregg",
  "item.minecraft.strider_spawn_egg": "röltara framköllunaregg",
  "item.minecraft.trader_llama_spawn_egg": "sölumannslamadýrs framköllunaregg",
  "item.minecraft.tropical_fish_spawn_egg": "hitabeltisfisks framköllunaregg",
  "item.minecraft.turtle_spawn_egg": "skjaldböku framköllunaregg",
  "item.minecraft.vex_spawn_egg": "ergis framköllunaregg",
  "item.minecraft.villager_spawn_egg": "þorpsbúa framköllunaregg",
  "item.minecraft.vindicator_spawn_egg": "hakkara framköllunaregg",
  "item.minecraft.wandering_trader_spawn_egg": "farandsölumanns framköllunaregg",
  "item.minecraft.witch_spawn_egg": "nornar framköllunaregg",
  "item.minecraft.wither_skeleton_spawn_egg": "viðrinisbeinagrindar framköllunaregg",
  "item.minecraft.wolf_spawn_egg": "úlfs framköllunaregg",
  "item.minecraft.zoglin_spawn_egg": "nágaltar framköllunaregg",
  "item.minecraft.zombie_spawn_egg": "uppvaknings framköllunaregg",
  "item.minecraft.zombie_horse_spawn_egg": "uppvakningshests framköllunaregg",
  "item.minecraft.zombie_villager_spawn_egg": "uppvakningsþorpsbúa framköllunaregg",
  "item.minecraft.zombified_piglin_spawn_egg": "svíngengils framköllunaregg",
  "item.minecraft.experience_bottle": "reynsluflaska",
  "item.minecraft.fire_charge": "eldhnöttur",
  "item.minecraft.writable_book": "bók og fjaðurpenni",
  "item.minecraft.written_book": "skrifuð bók",
  "item.minecraft.emerald": "smaragður",
  "item.minecraft.item_frame": "hlutarrammi",
  "block.minecraft.flower_pot": "blómaker",
  "item.minecraft.carrot": "gulrót",
  "item.minecraft.potato": "kartafla",
  "item.minecraft.baked_potato": "bökuð kartafla",
  "item.minecraft.poisonous_potato": "eitruð kartafla",
  "item.minecraft.map": "tómt kort",
  "item.minecraft.golden_carrot": "gullrót",
  "block.minecraft.skeleton_skull": "hauskúpa",
  "block.minecraft.wither_skeleton_skull": "hauskúpa viðrinisbeinagrindar",
  "block.minecraft.player_head": "spilara höfuð",
  "block.minecraft.zombie_head": "höfuð uppvaknings",
  "block.minecraft.creeper_head": "höfuð af laumupúka",
  "block.minecraft.dragon_head": "drekahöfuð",
  "item.minecraft.carrot_on_a_stick": "gulrót á stöng",
  "item.minecraft.warped_fungus_on_a_stick": "brenglaður sveppur á stöng",
  "item.minecraft.nether_star": "heljarstjarna",
  "item.minecraft.pumpkin_pie": "graskers baka",
  "item.minecraft.firework_rocket": "raketta",
  "item.minecraft.firework_star": "flugeldastjarna",
  "item.minecraft.enchanted_book": "galdrabók",
  "item.minecraft.nether_brick": "heljarmúrsteinn",
  "item.minecraft.quartz": "heljarkvars",
  "item.minecraft.tnt_minecart": "námuvagn með sprengiefni",
  "item.minecraft.hopper_minecart": "námuvagn með trekt",
  "item.minecraft.prismarine_shard": "prismarínbrot",
  "item.minecraft.prismarine_crystals": "prismarínkristallar",
  "item.minecraft.rabbit": "hrátt kanínukjöt",
  "item.minecraft.cooked_rabbit": "eldað kanínukjöt",
  "item.minecraft.rabbit_stew": "kanínukássa",
  "item.minecraft.rabbit_foot": "kanínufótur",
  "item.minecraft.rabbit_hide": "kanínuskinn",
  "item.minecraft.armor_stand": "brynjustandur",
  "item.minecraft.iron_horse_armor": "járnhestabrynja",
  "item.minecraft.golden_horse_armor": "gullhestabrynja",
  "item.minecraft.diamond_horse_armor": "demantshestabrynja",
  "item.minecraft.leather_horse_armor": "leðurbrynja hests",
  "item.minecraft.lead": "ól",
  "item.minecraft.name_tag": "nafnspjald",
  "item.minecraft.command_block_minecart": "námuvagn með forritunarkubbi",
  "item.minecraft.mutton": "hrátt lambakjöt",
  "item.minecraft.cooked_mutton": "soðið lambakjöt",
  "block.minecraft.white_banner": "hvítur fáni",
  "block.minecraft.orange_banner": "appelsínugulur fáni",
  "block.minecraft.magenta_banner": "vínrauður fáni",
  "block.minecraft.light_blue_banner": "ljósblár fáni",
  "block.minecraft.yellow_banner": "gulur fáni",
  "block.minecraft.lime_banner": "límónugrænn fáni",
  "block.minecraft.pink_banner": "bleikur fáni",
  "block.minecraft.gray_banner": "grár fáni",
  "block.minecraft.light_gray_banner": "ljósgrár fáni",
  "block.minecraft.cyan_banner": "heiðblár fáni",
  "block.minecraft.purple_banner": "fjólublár fáni",
  "block.minecraft.blue_banner": "blár fáni",
  "block.minecraft.brown_banner": "brúnn fáni",
  "block.minecraft.green_banner": "grænn fáni",
  "block.minecraft.red_banner": "rauður fáni",
  "block.minecraft.black_banner": "svartur fáni",
  "item.minecraft.end_crystal": "endakristall",
  "item.minecraft.chorus_fruit": "kóraldin",
  "item.minecraft.popped_chorus_fruit": "sprett kóraldin",
  "item.minecraft.beetroot": "rauðrófa",
  "item.minecraft.beetroot_seeds": "rauðrófufræ",
  "item.minecraft.beetroot_soup": "rauðrófusúpa",
  "item.minecraft.dragon_breath": "drekavindur",
  "item.minecraft.splash_potion": "skvetta óbrugganlegu seyði□engin áhrif",
  "item.minecraft.spectral_arrow": "draugaör",
  "item.minecraft.tipped_arrow": "ekki iðn áfengi ör□engin áhrif",
  "item.minecraft.lingering_potion": "langvinnt óbrugganlegt seyði□engin áhrif",
  "item.minecraft.shield": "skjöldur",
  "item.minecraft.elytra": "þekjuvængir",
  "item.minecraft.spruce_boat": "grenibátur",
  "item.minecraft.birch_boat": "birkibátur",
  "item.minecraft.jungle_boat": "frumskógarviðarbátur",
  "item.minecraft.acacia_boat": "akasíubátur",
  "item.minecraft.dark_oak_boat": "dökkeikarbátur",
  "item.minecraft.totem_of_undying": "tótem ódauðleika",
  "item.minecraft.shulker_shell": "shulkerskel",
  "item.minecraft.iron_nugget": "járnmoli",
  "item.minecraft.knowledge_book": "fræðabók",
  "item.minecraft.debug_stick": "kembiprik",
  "item.minecraft.music_disc_13": "vínýll□c418 - 13",
  "item.minecraft.music_disc_cat": "vínýll□c418 - cat",
  "item.minecraft.music_disc_blocks": "vínýll□c418 - blocks",
  "item.minecraft.music_disc_chirp": "vínýll□c418 - chirp",
  "item.minecraft.music_disc_far": "vínýll□c418 - far",
  "item.minecraft.music_disc_mall": "vínýll□c418 - mall",
  "item.minecraft.music_disc_mellohi": "vínýll□c418 - mellohi",
  "item.minecraft.music_disc_stal": "vínýll□c418 - stal",
  "item.minecraft.music_disc_strad": "vínýll□c418 - strad",
  "item.minecraft.music_disc_ward": "vínýll□c418 - ward",
  "item.minecraft.music_disc_11": "vínýll□c418 - 11",
  "item.minecraft.music_disc_wait": "vínýll□c418 - wait",
  "item.minecraft.music_disc_pigstep": "vínýll□lena raine - pigstep",
  "item.minecraft.trident": "þríforkur□□þegar hún er í helstu hönd:□+8 árásar skaði□-2.9 árásarhraði",
  "item.minecraft.phantom_membrane": "vofuhimna",
  "item.minecraft.nautilus_shell": "perlusnekkju skel",
  "item.minecraft.heart_of_the_sea": "hjarta hafsins",
  "item.minecraft.crossbow": "lásbogi",
  "item.minecraft.suspicious_stew": "grunsamleg kássa",
  "block.minecraft.loom": "vefstóll",
  "item.minecraft.flower_banner_pattern": "fánamynstur□blómamynstur",
  "item.minecraft.creeper_banner_pattern": "fánamynstur□laumupúkamynstur",
  "item.minecraft.skull_banner_pattern": "fánamynstur□hauskúpumynstur",
  "item.minecraft.mojang_banner_pattern": "fánamynstur□hlutmynstur",
  "item.minecraft.globe_banner_pattern": "fánamynstur□hnattmynstur",
  "item.minecraft.piglin_banner_pattern": "fánamynstur□trýni",
  "block.minecraft.composter": "moltukassi",
  "block.minecraft.barrel": "tunna",
  "block.minecraft.smoker": "reykofn",
  "block.minecraft.blast_furnace": "bræðsluofn",
  "block.minecraft.cartography_table": "kortaborð",
  "block.minecraft.fletching_table": "fjöðrunarbekkur",
  "block.minecraft.grindstone": "smergel",
  "block.minecraft.lectern": "ræðupúlt",
  "block.minecraft.smithing_table": "járnsmíðabekkur",
  "block.minecraft.stonecutter": "steinskeri",
  "block.minecraft.bell": "bjalla",
  "block.minecraft.lantern": "ljósker",
  "block.minecraft.soul_lantern": "sálarljósker",
  "item.minecraft.sweet_berries": "sætuber",
  "block.minecraft.campfire": "varðeldur",
  "block.minecraft.soul_campfire": "sálarvarðeldur",
  "block.minecraft.shroomlight": "sveppaljós",
  "item.minecraft.honeycomb": "vaxkaka",
  "block.minecraft.bee_nest": "býkúpa",
  "block.minecraft.beehive": "býflugnabú",
  "item.minecraft.honey_bottle": "hunangsflaska",
  "block.minecraft.honey_block": "hunangskubbur",
  "block.minecraft.honeycomb_block": "vaxkökukubbur",
  "block.minecraft.lodestone": "varða",
  "block.minecraft.netherite_block": "heljarmálmskubbur",
  "block.minecraft.ancient_debris": "fornleifar",
  "block.minecraft.target": "skotmark",
  "block.minecraft.crying_obsidian": "grátandi hrafntinna",
  "block.minecraft.blackstone": "svartgrýti",
  "block.minecraft.blackstone_slab": "svartgrýtishella",
  "block.minecraft.blackstone_stairs": "svartgrýtiströppur",
  "block.minecraft.gilded_blackstone": "gyllt svartgrýti",
  "block.minecraft.polished_blackstone": "slípað svartgrýti",
  "block.minecraft.polished_blackstone_slab": "slípuð svartgrýtishella",
  "block.minecraft.polished_blackstone_stairs": "slípaðar svartgrýtiströppur",
  "block.minecraft.chiseled_polished_blackstone": "tilhöggvið slípað svartgrýti",
  "block.minecraft.polished_blackstone_bricks": "slípaðir svartgrýtismúrsteinar",
  "block.minecraft.polished_blackstone_brick_slab": "slípuð svartgrýtismúrsteinshella",
  "block.minecraft.polished_blackstone_brick_stairs": "slípaðar svartgrýtismúrsteinströppur",
  "block.minecraft.cracked_polished_blackstone_bricks": "brotnir slípaðir svartgrýtismúrsteinar",
  "block.minecraft.respawn_anchor": "endurlífgunar akkeri",
}
export const is_is = items; 
